import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import authService from 'services/authService';
import "views/signIn/SignIn.css";

export const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    // Configuración Toast global
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });

    const showError = (message) => {
        Toast.fire({
            icon: 'error',
            title: message
        });
    };

    const showSuccess = (message) => {
        Toast.fire({
            icon: 'success',
            title: message
        });
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email.trim()) {
            showError('El correo electrónico es requerido');
            return;
        }

        if (!validateEmail(email)) {
            showError('Ingresa un correo electrónico válido');
            return;
        }

        setLoading(true);

        try {
            const result = await authService.forgotPassword(
                email.trim().toLowerCase()
            );

            if (result.error) {
                showError(result.data || 'Error al procesar la solicitud');
                setLoading(false);
                return;
            }

            showSuccess(
                'Si el correo existe, recibirás instrucciones para restablecer tu contraseña.'
            );

            setTimeout(() => {
                navigate('/sign-in');
            }, 2000);

        } catch (err) {
            showError('Error de conexión. Por favor, intenta nuevamente.');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="back-to-landing-container">
                <button
                    className="back-to-landing"
                    onClick={() => navigate('/sign-in')}
                >
                    ← Volver al Login
                </button>
            </div>

            <div className="login-container">
                <div className="login-logo">
                    <div className="logo-login" onClick={() => navigate("/")}>
                        <img
                            src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
                            height="46"
                            alt="María Bonita Logo"
                        />
                    </div>
                </div>

                <h2 className="login-title">Recuperar Contraseña</h2>
                <p className="login-subtitle">
                    Ingresa tu correo electrónico y te enviaremos instrucciones
                    para restablecer tu contraseña
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">
                            Correo Electrónico
                        </label>
                        <input
                            type="email"
                            className="form-input"
                            placeholder="usuario@ejemplo.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-full"
                        disabled={loading}
                    >
                        {loading ? 'Enviando...' : 'Enviar Instrucciones'}
                    </button>

                    <div className="register-link">
                        <p>
                            <Link to="/sign-in">
                                Volver al inicio de sesión
                            </Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};
